// Mark taken from the TOYAM bottle label: twin mountain peaks drawn as nested chevrons.
export const Emblem = ({ className = "h-5 w-auto", stroke = "currentColor" }) => (
  <svg viewBox="0 0 44 22" className={className} fill="none" stroke={stroke} strokeWidth="1.5" strokeLinejoin="miter" strokeLinecap="square" aria-hidden="true">
    <path d="M1 21 L12 5 L22 18 L32 5 L43 21" />
    <path d="M7 21 L12 13.5 L17 20.5" />
    <path d="M27 20.5 L32 13.5 L37 21" />
  </svg>
);

export const Logo = ({ tone = "ivory", className = "" }) => {
  const color = tone === "ivory" ? "#F8F3E9" : "#26231F";
  return (
    <span className={`inline-flex flex-col items-center gap-1.5 ${className}`} aria-label="TOYAM">
      <Emblem className="h-[16px] w-auto" stroke="#B18A4A" />
      <span className="font-serif-lux text-[21px] font-medium leading-none tracking-[0.16em]" style={{ color }}>TOYAM</span>
    </span>
  );
};
